<template>
  <div class="row mt-4">
    <div class="col-12 text-uppercase">
      <h4><b>Adicionar produtos por Excel</b></h4>
    </div>

    <div class="col-2 mt-4">
      <label>Id Lojista:</label>
      <input type="text" class="form-control" placeholder="####" @blur="buscarLojista()" v-model="lojista_id">
    </div>

    <div class="col-5 mt-4">
      <label>Lojista selecionado:</label>
      <input type="text" class="form-control" placeholder="Selecione um lojista" readonly v-model="lojista_nome">
    </div>

    <div class="col-5 mt-4">
      <b-row
        class="align-items-center border-r5 p-2 pointer mt-4"
        style="border: 1px dashed #28a745; background-color: #eee; width:100%"
      >
        <b-col cols="10">
          <input type="file" accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" @change="handleFileUpload">
        </b-col>
        <b-col class="text-right">
          <i class="fas fa-cloud-upload-alt fs-30 text-success"></i>
        </b-col>
      </b-row>
    </div>

    <div class="col-12 mt-4" v-if="produtos != null && produtos.length">
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th class="text-left">Produto</th>
            <th class="text-left">Cód. barras</th>
            <th class="text-center">Preço</th>
            <th class="text-center">C. estoque</th>
            <th class="text-center">Qtd. estoque</th>
            <th class="text-center">Retirada em um dia</th>
            <th class="text-center">Desconto(%)</th>
            <th class="text-center">Cód. interno</th>
            <th class="text-center">Desconto(R$)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in produtos" :key="i">
            <td class="text-left">{{item.produto ? item.produto : '-'}}</td>
            <td class="text-left">{{item.cod_bar ? item.cod_bar : '-'}}</td>
            <td class="text-center">{{item.preco ? formatarNumber(item.preco) : '-'}}</td>
            <td class="text-center">{{item.qtd_estoque && item.qtd_estoque > 0 ? 'Sim': 'Não'}}</td>
            <td class="text-center">{{item.qtd_estoque ? item.qtd_estoque : '-'}}</td>
            <td class="text-center">{{item.retira_um_dia && item.retira_um_dia == true ? 'Sim' : 'Não'}}</td>
            <td class="text-center">
              {{item.desconto ? item.desconto : '-'}}
            </td>
            <td class="text-center">{{item.cod_interno ? item.cod_interno : '-'}}</td>
            <td class="text-center">{{item.desconto_valor ? formatarNumber(item.desconto_valor) : '-'}}</td>
          </tr>
        </tbody>
      </table>

      <div class="row mb-4">
        <div class="col-12 text-center">
          <button class="btn btn-success pr-5 pl-5" @click="addProdutos()" :disabled="lojista_nome == ''">Adicionar produtos</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import makeToast from '@/mixins/makeToast';
export default {
  name: 'importarexcel',
  mixins: [makeToast],
  data() {
    return {
      lojista_id: null,
      lojista_nome: '',
      produtos: null,
      proutoExiste: [],
      proutoNaoExiste: [],
      proutoCadastrado: []
    };
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: 'binary' });
          const sheetName = workbook.SheetNames[0]; // Assuming we have data in the first sheet
          const jsonData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
          this.produtos = jsonData;
        };
        reader.readAsBinaryString(file);
      }
    },
    formatarNumber(price) {
      price = price.toString();

      var value = price.replace(/R\$|\s/g, '');
      value = value.replace(',', '.');

      if (!value.match(/\./)) {
        value = value + '.00';
      }

      let numeroCorrigido = value.replace(/\./g, '');
      numeroCorrigido = numeroCorrigido.slice(0, -2) + '.' + numeroCorrigido.slice(-2);

      const floatValue = parseFloat(numeroCorrigido);
      return Intl.NumberFormat('pt-BR', {currency: 'BRL', style: 'currency'}).format(floatValue);
    },
    buscarLojista() {
      this.lojista_nome = '';
      this.produtos = null;
      this.proutoExiste = [];
      this.proutoNaoExiste = [];
      this.proutoCadastrado = [];

      if(this.lojista_id == '' || this.lojista_id == null) {
        return;
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/buscarLojinstaId', this.lojista_id)
        .then((response) => {
          if(response.data.nome_fantasia) {
            this.lojista_nome = response.data.nome_fantasia+' - CNPJ:'+response.data.cnpj;
          } else {
            this.lojista_id = null;
            this.makeToast('Oops', 'Lojista não encontrado!', 'danger');
          }
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        })
    },
    addProdutos() {
      if(this.lojista_id == '' || this.lojista_id == null) {
        this.makeToast('Oops', 'Informe o lojista!', 'danger');
        return;
      }

      if(this.produtos.length == 0) {
        return;
      }

      const produtos = this.produtos.slice(0, 30);

      const data = {
        lojista_id: this.lojista_id,
        produtos: produtos
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/addProdutosExcelIa', data)
        .then((response) => {

        })
        .finally(() => {
          this.$store.dispatch('endLoader');

          this.produtos = this.produtos.slice(30);

          if(this.produtos.length > 0) {
            this.addProdutos();
          }
        })
    }
  },
};
</script>

<style scoped>
#inseridos tr td, #inseridos tr th {
  border: 2px solid green !important;
}
#jainseridos tr td, #jainseridos tr th {
  border: 2px solid blue !important;
}
#naoinseridos tr td, #naoinseridos tr th {
  border: 2px solid red !important;
}
</style>
